import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { tableTheme } from '../../helpers/tableTheme';

import { Spinner } from '@themesberg/react-bootstrap';
import ColorComponent from '../../components/ColorComponent';
import {
  clearPendingBatches,
  getPendingBatches,
} from '../../redux/actions/notification';

const columns = [
  'Batch Id',
  'Collector Name',
  'Collector Contact Number',
  'Date',
  {
    name: 'Status',
    options: {
      customBodyRender: (value) => {
        return <ColorComponent value={value} />;
      },
    },
  },
  'Total Transactions',
];

const PendingBatches = ({ history }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { pendingBatchesData } = useSelector((state) => state.notification);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getPendingBatches('PENDING')).then(() => setIsLoading(false));
    return () => {
      dispatch(clearPendingBatches());
    };
  }, []);

  const onRowsSelect = (rowData, rowMeta) => {
    history.push(`/transactions/batch/${rowData[0]}`);
  };
  const options = {
    filterType: 'checkbox',
    selectableRowsOnClick: false,
    onRowClick: onRowsSelect,
    responsive: 'standard',
    print: false,
    download: false,
    filter:false
  };

  return (
    <>
      <div>
        <MuiThemeProvider theme={tableTheme}>
          {isLoading ? (
            <div
              className='d-flex justify-content-center align-items-center'
              style={{
                height: '50vh',
              }}
            >
              <Spinner animation='border' />
            </div>
          ) : (
            <MUIDataTable
              title={`Pending batches`}
              data={pendingBatchesData}
              columns={columns}
              options={options}
            />
          )}
        </MuiThemeProvider>
      </div>
    </>
  );
};

export default PendingBatches;
